module.exports = __webpack_public_path__ + "fonts/Inter-600-cyrillic-ext57.df55b7e.woff2";